import React from 'react'

import {
  Grid,
  Button,
  FlexBox,
  Columns,
  AlignItems,
  FunnelPage,
  AppWrapper,
  ComponentSize,
  FlexDirection,
  ComponentColor,
} from '@influxdata/clockface'

import InfluxDataLogo from 'js/components/InfluxDataLogo'
import FunnelHeader from '../shared/FunnelHeader'
import FunnelSubheader from '../shared/FunnelSubheader'

interface Props {
  orgName: string
}

const InviteCancelledAccount = ({orgName}: Props): JSX.Element => {
  return (
    <AppWrapper type="funnel">
      <FunnelPage logo={<InfluxDataLogo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <FlexBox
              direction={FlexDirection.Column}
              alignItems={AlignItems.Center}
              margin={ComponentSize.Large}
            >
              <FunnelHeader text="This invitation has expired" />
              <FunnelSubheader
                text={`The account associated with this invitation has been cancelled. Please contact the owner of ${orgName}.`}
              />
              <a href="/signup">
                <Button
                  text="Create new Account"
                  size={ComponentSize.Large}
                  color={ComponentColor.Default}
                />
              </a>
            </FlexBox>
          </Grid.Column>
        </Grid.Row>
      </FunnelPage>
    </AppWrapper>
  )
}

export default InviteCancelledAccount
